<template>
  <div class="item-remove">
    <button type="button" class="item-remove__button" @click="remove">Remove</button>
  </div>
</template>

<script lang="ts" setup>
import { useCartInject } from '../../context/useCartContext'
import { LiquidLineItem } from '../../types/liquid'

const { removeLineItems } = useCartInject()

const props = defineProps<{
  line: LiquidLineItem
}>()

const remove = async () => {
  await removeLineItems([{ id: props.line.key }])
}
</script>

<style lang="scss">
@import '~styles/base';

.item-remove {
  padding-top: 15px;
  cursor: pointer;

  > * {
    /* @include animate-underline; */
    text-decoration: underline;

    @include hover {
      text-decoration: none;
    }
  }
}
</style>
